"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildPersonPermissionsPath = buildPersonPermissionsPath;
exports.PersonPermissionsButton = PersonPermissionsButton;
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const MainSetupReact_1 = __importDefault(require("../React/MainSetupReact"));
const CommonComponents_1 = require("../View/Resultsets/CommonComponents");
function buildPersonPermissionsPath(person) {
    const params = new URLSearchParams();
    params.set("fraza", `${person.name ?? ""} ${person.surname ?? ""}`.trim());
    // Rola i podmiot (uwaga ownera 2026-09-04, PER-8): imiennicy różnią się zwykle podmiotem,
    // a fraza łapie też nazwiska zawierające imię (Adam → Adamczyk). Obie listy czytają rolę
    // z tego samego źródła (konto, z zapasem na zaszłą kolumnę), więc filtr trafia w tę samą osobę.
    const roleId = Number(person.systemRoleId);
    if (person.systemRoleId !== undefined && person.systemRoleId !== null && Number.isInteger(roleId) && roleId > 0)
        params.set("rola", String(roleId));
    const entityId = Number(person._entity?.id);
    if (Number.isInteger(entityId) && entityId > 0) {
        params.set("podmiot", String(entityId));
        if (person._entity?.name)
            params.set("podmiotNazwa", person._entity.name);
    }
    return `/admin/staffMembers?${params.toString()}`;
}
/**
 * Pomost z książki adresowej do kont i uprawnień tej samej osoby (PER-4).
 *
 * Dwa okna zostają — „Osoby” odpowiadają na pytanie kto to jest, „Personel i uprawnienia”
 * na pytanie co może w systemie — ale administrator nie musi szukać człowieka drugi raz.
 *
 * Akcja widoczna tylko dla ról panelu administracyjnego: okno docelowe stoi na tej samej
 * stałej, a serwer bramkuje trasy konta rolami ADMIN i ENVI_MANAGER. Pokazanie jej
 * pracownikowi ENVI dałoby ikonę prowadzącą w pustą trasę.
 */
function PersonPermissionsButton({ dataObject, layout }) {
    const navigate = (0, react_router_dom_1.useNavigate)();
    if (!MainSetupReact_1.default.isRoleAllowed(MainSetupReact_1.default.ADMIN_PANEL_ROLES))
        return null;
    return (react_1.default.createElement("span", { title: "Uprawnienia" },
        react_1.default.createElement(CommonComponents_1.PermissionsIconButton, { layout: layout, onClick: () => navigate(buildPersonPermissionsPath(dataObject)) })));
}
